import React, { FunctionComponent, ReactNode, useContext } from "react";
import useTestEnvironment from "./useTestEnvironment";
import { cache } from "@/Contracts";
import { cacheConstant } from "@/Contracts/appCache";

import { FlagsContext, featureFlagInterface, isVendorApp } from "@/Utils";
import { getFeatureFlagOverride } from "@/Utils/featureFlagOverride";

const environmentMapping = (envVal: string) => {
	switch (envVal) {
		case "production":
			return process.env.REACT_APP_PRODUCTION_ENVIRONMENT_ID;
		case "canary":
			return process.env.REACT_APP_CANARY_ENVIRONMENT_ID;
		default:
			return process.env.REACT_APP_STAGE_ENVIRONMENT_ID;
	}
};

export const useGenerateFeatureFlagConfig = () => {
	// Boolean flags
	const key_for_testing = "key_for_testing"; // For testing purpose

	const audit_logs_retry_button = "audit_logs_retry_button"; //Ajinkya

	const payment_summary_block = "payment_summary_block"; //Lakshya
	const beamer_icon = "beamer_icon"; // lakshya
	const stripe = "stripe"; //Lakshya
	const halopsa = "halopsa"; //Lakshya
	const show_superops_integration_card = "show_superops_integration_card"; //Sameer
	const push_to_psa = "push_to_psa"; //Lakshya
	const real_time_only_kaseya = "real_time_only_kaseya"; //Lakshya
	const real_time_only_syncro = "real_time_only_syncro"; //Lakshya
	const real_time_only_repairshopr = "real_time_only_repairshopr"; //Lakshya
	const real_time_only_cw = "real_time_only_cw"; //Lakshya
	const real_time_only_at = "real_time_only_at"; //Lakshya
	const merge_duplicate_products_alert = "merge_duplicate_products_alert"; //Harmeet
	const is_marketplace_disabled = "is_marketplace_disabled"; //Harmeet

	const push_to_psa_first_rollout = "push_to_psa_first_rollout"; //Ajinkya
	const move_preferences_global = "move_preferences_global"; // Idrees
	const fix_bundle_child_edit_isolation = "fix_bundle_child_edit_isolation"; //sameer
	const move_documents_across_clients = "move_documents_across_clients"; // Idrees
	const v2_quote_pdf_widgets = "v2_quote_pdf_widgets"; // Rahil — ZE-40004 PDF widget kill switch

	const product_search_sorting = "product_search_sorting"; //Kartikay

	const drawer_close_warning = "drawer_close_warning"; //Pravasith
	const push_to_psa_crm_autotask = "push_to_psa_crm_autotask"; //Pravasith

	const send_id_to_address = "send_id_to_address"; //Ajinkya
	const send_doc_using_nylas = "send_doc_using_nylas"; //Abhishek -> Enabled for few companies

	const loading_animation = "loading_animation"; //Tushar
	const etilize_pricing = "etilize_pricing"; //Tushar

	const kaseya_multi_pipeline_mapping = "kaseya_multi_pipeline_mapping"; // pradeep --> used for Integration onBoarding

	const use_calendly_for_marketplace_product_details =
		"use_calendly_for_marketplace_product_details"; //sajan
	const marketplace_sku = "marketplace_sku"; //kartikay

	const automation_send_document_attachments =
		"automation_send_document_attachments"; //vijay

	const customfield_currency_datatype = "customfield_currency_datatype"; //Vijay

	const sellprice_auto_roundoff = "sellprice_auto_roundoff"; //Vijay

	const view_and_filter_sales_automation = "view_and_filter_sales_automation"; //Shivam

	const receiver_merge_tags = "receiver_merge_tags"; //Shivam

	const new_document_send_view = "new_document_send_view"; //Vijay

	const hubspot_pull_activities_filter = "hubspot_pull_activities_filter"; //Ajinkya
	const hubspot_push_pdf_attachment = "hubspot_push_pdf_attachment"; //Ajinkya

	const po_item_statuses = "po_item_statuses"; //Ashish

	const risk_matrix_editing_in_preferences =
		"risk_matrix_editing_in_preferences"; // Ashish

	const vendor_hubspot_integration = "vendor_hubspot_integration"; //ajinkya

	const sales_activity_views_and_filters = "sales_activity_views_and_filters"; //Shivam

	const in_app_onboarding = "in_app_onboarding"; // Vijay
	const vendor_template_quote_blocks = "vendor_template_quote_blocks"; // ajinkya

	const enable_deep_link = "enable_deep_link"; // shivang

	const push_to_psa_enhancement = "push_to_psa_enhancement"; // ajinkya

	const use_atlas_search = "use_atlas_search"; // Nemin

	const autotask_custom_fields_mapping = "autotask_custom_fields_mapping"; //Ajinkya

	const autotask_product_check_on_document_send =
		"autotask_product_check_on_document_send"; //Sameer

	const documents_client_opportunity_info =
		"documents_client_opportunity_info"; //Vijay

	const custom_distributors_file_separator_modal =
		"custom_distributors_file_separator_modal"; //pradeep;

	const connectwise_realtime_enhancement = "connectwise_realtime_enhancement"; // ajinkya

	const app_switcher_enabled = "app_switcher_enabled"; // Swadhin

	const payment_audit_logs = "payment_audit_logs"; // ajinkya

	const cw_custom_fields_mapping = "cw_custom_fields_mapping";

	const zomentum_payments = "zomentum_payments"; //Ajinkya
	const icecat_integration = "icecat_integration"; //Ashish

	const headers_footers = "headers_footers"; //Vijay
	const skip_margin_for_pdf_page = "skip_margin_for_pdf_page"; //Vijay

	const sign_request_input_field_placeholder =
		"sign_request_input_field_placeholder";
	const quote_block_revamp = "quote_block_revamp"; //Ashish
	const qbo_enhancement = "qbo_enhancement"; //Ajinkya
	const marketplace_pipeline_syncing = "marketplace_pipeline_syncing"; // Harmeet
	const partner_align_sales_automation_enhancements =
		"partner_align_sales_automation_enhancements"; // Harmeet

	const qbo_payment_mapping = "qbo_payment_mapping"; //Ajinkya

	const enable_bundles_enchancements = "enable_bundles_enchancements"; // sajan
	const icecat_enabled_for_all = "icecat_enabled_for_all"; //Ashish
	const always_allow_amazon_distributor = "always_allow_amazon_distributor"; //Sameer

	const push_tax_option_syncro = "push_tax_option_syncro"; //Ajinkya

	const enable_marketplace_comissions = "enable_marketplace_comissions"; // sajan

	const document_field_pdf_placeholder = "document_field_pdf_placeholder"; //Pradeep

	const hubspot_realtime_enhancement = "hubspot_realtime_enhancement"; // ajinkya

	const halo_multiple_type_mapping = "halo_multiple_type_mapping"; // ajinkya

	const save_view_tutorial = "save_view_tutorial"; // harmeet

	const email_thread_message_drawer_pa = "email_thread_message_drawer_pa"; // shivang

	const email_thread_message_drawer_grow = "email_thread_message_drawer_grow"; // shivang

	const search_etilize_product_drawer_func =
		"search_etilize_product_drawer_func"; // shivang

	const search_document_product_catalog_func =
		"search_document_product_catalog_func"; // shivang

	const document_roduct_configure_drawer_form_func =
		"document_roduct_configure_drawer_form_func";
	const audit_log_pagination = "audit_log_pagination"; //Shivam

	const halo_pipeline_stage_mapping = "halo_pipeline_stage_mapping"; // ajinkya

	const reset_mfa_and_password = "reset_mfa_and_password"; // ajinkya

	const manual_po = "manual_po"; // ajinkya
	const contact_opporuntiy_document_card_v2 =
		"contact_opporuntiy_document_card_v2"; // Vijay
	const ai_document_builder = "ai_document_builder"; // kartikay

	const formula_fields = "formula_fields"; // Harmeet
	const formula_fields_generate_formula = "formula_fields_generate_formula"; // Harmeet

	const show_partner_align_features = "show_partner_align_features"; // Harmeet
	const multi_select_custom_fields = "multi_select_custom_fields"; // Ashish

	const hide_upload_pdf = "hide_upload_pdf"; //Vijay,
	const compact_view = "compact_view"; // Harmeet
	const sa_edit_opp_client_fields = "sa_edit_opp_client_fields"; // Harmeet

	const approval_rule_filter_v2 = "approval_rule_filter_v2"; // Vijay

	const custom_distributer_in_search_document_product_catalogue =
		"custom_distributer_in_search_document_product_catalogue"; // Harmeet
	const amazon_canada_region = "amazon_canada_region"; // Vijay

	const cddf_templates = "cddf_templates"; // Ashish

	const merge_entity_modal = "merge_entity_modal"; // Vijay

	const add_amazon_product_from_product_list_page =
		"add_amazon_product_from_product_list_page"; // Harmeet

	const cd_search_enhancement = "cd_search_enhancement"; // Vijay

	const document_single_block_editor = "document_single_block_editor"; // Harmeet

	const enable_custom_distributor_separate_tab =
		"enable_custom_distributor_separate_tab"; // Gurcharan

	const email_signature_html_editor = "email_signature_html_editor"; // Sameer

	const new_pricing_constraints = "new_pricing_constraints"; // Sales automation constraints

	const import_products_to_quote = "import_products_to_quote"; // Deepesh

	const unified_product_search = "unified_product_search"; // Harmeet

	const rtl_editor_support = "rtl_editor_support"; // Rahil

	const airtable_integration_enabled = "airtable_integration_enabled"; // Rahil

	const multi_currency_v1 = "multi_currency_v1";

	return {
		key_for_testing,
		beamer_icon,
		audit_logs_retry_button,
		etilize_pricing,
		send_doc_using_nylas,
		merge_duplicate_products_alert,
		product_search_sorting,
		is_marketplace_disabled,
		payment_summary_block,
		loading_animation,
		drawer_close_warning,
		send_id_to_address,
		push_to_psa_crm_autotask,
		stripe,
		kaseya_multi_pipeline_mapping,
		halopsa,
		show_superops_integration_card,
		push_to_psa,
		use_calendly_for_marketplace_product_details,
		real_time_only_kaseya,
		real_time_only_syncro,
		real_time_only_repairshopr,
		real_time_only_cw,
		real_time_only_at,
		push_to_psa_first_rollout,
		automation_send_document_attachments,
		marketplace_sku,
		customfield_currency_datatype,
		sellprice_auto_roundoff,
		view_and_filter_sales_automation,
		receiver_merge_tags,
		new_document_send_view,
		move_preferences_global,
		fix_bundle_child_edit_isolation,
		hubspot_pull_activities_filter,
		po_item_statuses,
		risk_matrix_editing_in_preferences,
		vendor_hubspot_integration,
		sales_activity_views_and_filters,
		in_app_onboarding,
		vendor_template_quote_blocks,
		enable_deep_link,
		push_to_psa_enhancement,
		use_atlas_search,
		autotask_custom_fields_mapping,
		autotask_product_check_on_document_send,
		documents_client_opportunity_info,
		custom_distributors_file_separator_modal,
		hubspot_push_pdf_attachment,
		connectwise_realtime_enhancement,
		app_switcher_enabled,
		payment_audit_logs,
		move_documents_across_clients,
		cw_custom_fields_mapping,
		zomentum_payments,
		headers_footers,
		icecat_integration,
		skip_margin_for_pdf_page,
		sign_request_input_field_placeholder,
		qbo_enhancement,
		quote_block_revamp,
		v2_quote_pdf_widgets,
		marketplace_pipeline_syncing,
		partner_align_sales_automation_enhancements,
		qbo_payment_mapping,
		enable_bundles_enchancements,
		icecat_enabled_for_all,
		push_tax_option_syncro,
		always_allow_amazon_distributor,
		enable_marketplace_comissions,
		document_field_pdf_placeholder,
		hubspot_realtime_enhancement,
		halo_multiple_type_mapping,
		save_view_tutorial,
		email_thread_message_drawer_pa,
		email_thread_message_drawer_grow,
		search_etilize_product_drawer_func,
		search_document_product_catalog_func,
		document_roduct_configure_drawer_form_func,
		audit_log_pagination,
		halo_pipeline_stage_mapping,
		reset_mfa_and_password,
		manual_po,
		contact_opporuntiy_document_card_v2,
		formula_fields,
		formula_fields_generate_formula,
		ai_document_builder,
		show_partner_align_features,
		multi_select_custom_fields,
		hide_upload_pdf,
		compact_view,
		sa_edit_opp_client_fields,
		approval_rule_filter_v2,
		custom_distributer_in_search_document_product_catalogue,
		amazon_canada_region,
		cddf_templates,
		merge_entity_modal,
		add_amazon_product_from_product_list_page,
		cd_search_enhancement,
		document_single_block_editor,
		enable_custom_distributor_separate_tab,
		new_pricing_constraints,
		import_products_to_quote,
		unified_product_search,
		email_signature_html_editor,
		rtl_editor_support,
		airtable_integration_enabled,
		multi_currency_v1
	};
};

const useInternalFeatureFlag = (
	flag: keyof ReturnType<typeof useGenerateFeatureFlagConfig>,
	mandatoryId?: string | null
): boolean => {
	const { featureFlagsList, featureFlagsProjectData } =
		useContext(FlagsContext);
	const featureFlagInfo: featureFlagInterface = featureFlagsList[flag];

	if (!featureFlagsList || !featureFlagsProjectData || !featureFlagInfo) {
		return false;
	}

	const currentEnvironment = process.env.REACT_APP_NODE_ENV || "";
	if (!featureFlagInfo?.status || featureFlagInfo?.strategies?.length === 0) {
		return false;
	}

	const currentEnvironmentId = environmentMapping(currentEnvironment) || "";

	const allowedStrategies = featureFlagInfo?.strategies.filter(st =>
		st.environment_for_strategy.includes(currentEnvironmentId)
	);
	const strategyType = allowedStrategies.map(st => st.strategy_type);
	if (allowedStrategies?.length === 0) {
		return false;
	} else if (strategyType?.includes("all_users")) {
		return true;
	} else {
		const entityIds = allowedStrategies.map(st => st.entity_list_id);
		const allowedIds = featureFlagsProjectData.entity_lists
			.filter(et => entityIds.includes(et.id))
			.flatMap(et => et.entity_ids);

		return allowedIds.includes(mandatoryId || "");
	}
};

const useFeature = (
	flag: keyof ReturnType<typeof useGenerateFeatureFlagConfig>
): boolean | undefined => {
	const cacheUserData = cache.get(cacheConstant.userData, true);

	const companyId = isVendorApp()
		? cacheUserData?.vendor_company_id
		: cacheUserData?.company_id;

	const internalUseOnly =
		[
			"b4c2e72388fd4a4c9cf59eecd92546a3",
			"53c2874f54fa476cb67b2441bf359a64",
			"ce60725644a64fcb9a5fbe32dde09c18",
			"dc378043d1e2459880194ab79fa173ca",
			"c9c5ba8d58394469907da934879f7761"
		].includes(companyId) &&
		process.env.REACT_APP_NODE_ENV === "production";
	const internalFlagValue = useInternalFeatureFlag(flag, companyId);
	if (internalUseOnly) {
		return true;
	}
	return internalFlagValue;
};

interface FeatureFlagProps {
	flag: keyof ReturnType<typeof useGenerateFeatureFlagConfig>;
	fallback?: ReactNode;
	mandatoryId?: string;
}
export const FeatureFlag: FunctionComponent<FeatureFlagProps> = ({
	children,
	flag,
	fallback = null
}) => {
	const isFlagEnabled = useFeatureFlag(flag);
	return <>{isFlagEnabled ? children : fallback}</>;
};

export const useFeatureFlag = (
	feature: keyof ReturnType<typeof useGenerateFeatureFlagConfig>
): boolean => {
	const isTesting = useTestEnvironment();
	const config = useFeature(feature);
	const queryParamOverride = getFeatureFlagOverride(feature);

	if (queryParamOverride !== null) {
		return queryParamOverride;
	}

	return config || isTesting ? true : false;
};

export const useFlagsLoaded = (): boolean => {
	const { flagsLoaded } = useContext(FlagsContext);
	return flagsLoaded;
};
